import { either, isEmpty, isNil } from 'ramda'

export function isEmptyOrNil(value): value is null | undefined {
  return either(isEmpty, isNil)(value)
}
